export const API_CONFIG = {
    baseUrl: process.env.API_BASE_URL || 'https://inconconnect.avantgarde-software.com',
    endpoints: {
        auth: '/api/idwell/auth',
        buildings: '/api/idwell/buildings',
        contracts: '/api/idwell/contracts',
        incidentCategories: '/api/idwell/incident-questions',
        incidentFields: '/api/idwell/incident-fields',
        submitForm: '/api/idwell/incident',
        properties: '/api/:externalSystem/properties',
        allProperties: '/api/:externalSystem/properties/all',
        units: '/api/:externalSystem/properties/:propertyId/units',
        residents: '/api/:externalSystem/properties/:propertyId/residents',
        contactDetails: '/api/:externalSystem/residents/contact-details',
        providers: '/api/:externalSystem/providers',
        deeplinkResolve: '/api/deeplink/resolve'
    },
    debugMode: false, // Set to true for debugging
};
